import EventBus from "src/services/utils/appEventBusService"
import appConsoleService from "src/services/utils/appConsoleService";

const errorUrl = "/static/audio/error.mp3";
const infoUrl  = "/static/audio/info.mp3";
const SOUND_KEY = "pappus.notif.sound";

export const SESSION_EXPIRED_MESSAGE = "Ta session a expiré, reconnecte-toi."

class _AppNotificationService {

  constructor() {
    this.soundEnabled = this.readSoundPreference()
  }

  readSoundPreference() {
    try {
      return localStorage.getItem(SOUND_KEY) !== '0'
    } catch (e) {
      return true
    }
  }

  /** Son des notifications activé ? (réglé depuis le panneau de la cloche) */
  isSoundEnabled() {
    return this.soundEnabled
  }

  setSoundEnabled(enabled) {
    this.soundEnabled = !!enabled
    try {
      localStorage.setItem(SOUND_KEY, enabled ? '1' : '0')
    } catch (e) {
      // Stockage indisponible : réglage conservé pour la session
    }
  }

  playSound(url) {
    if (!this.soundEnabled) return
    // Le navigateur peut refuser la lecture tant que l'utilisateur n'a pas interagi
    new Audio(url).play().catch(() => {})
  }

  /**
   * Function which push an info message
   */
  pushInfo(message) {

    if (message) {
      EventBus.emit('notify', {
        group: 'custom-template', //foo-css
        title: 'Information',
        message: message,
        type: 'information',
        data: {
          randomNumber: Math.random(),
        }
      })

      this.playSound(infoUrl);
    }
  }

  /**
   * Function which push an warning message
   */
  pushWarning(message) {
    if (message) {
      EventBus.emit('notify', {
        group: 'custom-template',
        title: 'Warning',
        message: message,
        type: 'warning',
        data: {
          randomNumber: Math.random(),
        }
      })
    }
  }

  /**
   * Function which push an erroir message
   */
  pushError(error) {
    appConsoleService.error('appNotificationService',error);
    // Session expirée : l'intercepteur axios renvoie à la connexion, sans message
    if (error && (error.sessionExpired || error === SESSION_EXPIRED_MESSAGE)) return
    if (error) {

      let message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();

      EventBus.emit('notify', {
        group: 'custom-template',
        title: 'Error',
        message: message,
        type: 'error',
        data: {
          randomNumber: Math.random(),
        }
      })

      this.playSound(errorUrl);

    }

  }
}

export default new _AppNotificationService();
